import { render, staticRenderFns } from "./CorrespondentFinancial.vue?vue&type=template&id=f241a7c4"
import script from "./CorrespondentFinancial.vue?vue&type=script&lang=js"
export * from "./CorrespondentFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports